export const selectList = (state, entity, subEntity) => {
    return state[entity][subEntity];
};

export const selectListPagination = (state, entity, subEntity) => {
    return selectList(state, entity, subEntity)?.pagination || null;
};
